import { Content } from '@prismicio/client';
import { SliceComponentProps } from '@prismicio/react';
import { PrismicRichText } from '@prismicio/react';
import { PrismicNextImage } from '@prismicio/next';

/**
 * Props for `ValuesGrid`.
 */
export type ValuesGridProps = SliceComponentProps<Content.ValuesGridSlice>;

/**
 * Component for "ValuesGrid" Slices.
 */
const ValuesGrid = ({ slice }: ValuesGridProps): JSX.Element => {
  const {
    primary: { headline, values },
  } = slice;
  return (
    <section
      data-slice-type={slice.slice_type}
      data-slice-variation={slice.variation}
      className="h-auto bg-[linear-gradient(to_bottom,#FFFFFF_0%,#FFFFFF_50%,#B6F6EA_100%)] py-10 md:py-12"
    >
      <div className="container mx-auto px-4 md:px-6 text-black h-full flex flex-col items-start justify-start">
        <div className="flex flex-col items-start gap-y-8 md:gap-y-10 w-full">
          <div
            className="text-left font-bold text-3xl sm:text-4xl md:text-5xl leading-tight max-w-3xl pl-0 md:pl-0 ml-10"
            style={{
              fontWeight: '700',
              fontSize: '40px',
              lineHeight: '120%',
            }}
          >
            <PrismicRichText field={headline} />
          </div>
          <div className="w-full flex flex-row flex-nowrap overflow-x-auto lg:grid lg:grid-cols-3 lg:gap-6 gap-x-6 pt-4 pb-4 no-scrollbar">
            {values.map((item, index) => (
              <div
                className="flex flex-col items-start text-left 
                              gap-y-4 md:gap-y-5
                              p-6
                              bg-white 
                              shadow-[0px_4.32px_64.87px_0px_rgba(0,0,0,0.08)]
                              w-72 md:w-80
                              lg:w-full
                              flex-shrink-0
                              lg:flex-shrink"
                style={{
                  backgroundColor: '#FFFFFF',
                }}
                key={`value-card-${index}`}
              >
                <PrismicNextImage
                  field={item.icon}
                  className="h-10 w-10 md:h-12 md:w-12 object-contain mb-2"
                />
                <div
                  className="font-bold text-xl md:text-2xl leading-snug text-gray-900"
                  style={{
                    fontWeight: '700',
                    fontSize: '24px',
                    lineHeight: '140%',
                  }}
                >
                  <PrismicRichText field={item.item_title} />
                </div>
                <div
                  className="font-normal text-base leading-relaxed text-gray-700"
                  style={{
                    fontWeight: '400',
                    fontSize: '16px',
                    lineHeight: '150%',
                  }}
                >
                  <PrismicRichText field={item.description} />
                </div>
              </div>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
};

export default ValuesGrid;
